import React, { FunctionComponent, useState } from 'react'
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import app from '../../firebase/initialize'

import { ReactComponent as Logo } from '../../components/atoms/Icons/logo.svg'
import { ReactComponent as MailIcon } from '../../components/atoms/Icons/mail-icon.svg'
import { ReactComponent as PasswordIcon } from '../../components/atoms/Icons/password-icon.svg'
import { useHistory } from 'react-router'

import * as S from './styled'
import { store } from '../../redux'
import { SIGN_IN } from '../../redux/misc/types'
import { useDispatch } from 'react-redux'
import { requestActions } from '../../redux/requests'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { PageRoute } from '../../navigation/constants'
import { MainState } from '../../redux/reducers'
import { Link } from 'react-router-dom'

interface OwnProps {
  emailVerified?: boolean
}

type Props = OwnProps

const SignIn: FunctionComponent<Props> = ({ emailVerified }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState({ error: false, message: '' })
  const dispatch = useDispatch()
  let uid = useSelector((state: MainState) => state.misc.uid)

  const auth = getAuth(app)
  const history = useHistory()
  const user = auth.currentUser

  const handleSubmit = e => {
    e.preventDefault()

    signInWithEmailAndPassword(auth, email, password)
      .then(userCredential => {
        dispatch(requestActions.auth.getUserByUid(userCredential.user.uid))
        store.dispatch({
          type: SIGN_IN,
          uid: userCredential.user.uid,
          token: userCredential.user['accessToken'],
        })
      })
      .catch(error => {
        const errorMessage =
          error.message === 'Firebase: Error (auth/wrong-password).'
            ? 'felaktigt lösenord'
            : error.message === 'Firebase: Error (auth/user-not-found).'
            ? 'användare finns ej'
            : error.message

        setError({
          error: true,
          message: errorMessage,
        })
      })
  }

  const handleChange = e => {
    e.preventDefault()
    const { name, value } = e.target
    if (name === 'password') {
      setPassword(value)
    } else {
      setEmail(value)
    }
  }

  if (!user) {
    uid = null
  }

  return uid ? (
    <Redirect to={PageRoute.START} />
  ) : (
    // <Logo />
    <S.Wrapper>
      <S.Container>
        <Logo height="150" viewBox="0 0 550 550" />
        <S.FormContainer>
          <S.Title>Logga in</S.Title>
          <S.Form onSubmit={handleSubmit}>
            <S.Label htmlFor={'email'}>Email</S.Label>
            <S.InputWrapper>
              <MailIcon />
              <S.Input type="email" name="email" value={email} onChange={handleChange} />
            </S.InputWrapper>
            <S.Label htmlFor={'password'}>Lösenord</S.Label>
            <S.InputWrapper>
              <PasswordIcon />
              <S.Input type="password" name="password" value={password} onChange={handleChange} />
            </S.InputWrapper>
            {error.error && <p style={{ color: '#fd3b37', textAlign: 'end' }}>{error.message}</p>}
            {!emailVerified && (
              <p style={{ color: '#fd3b37', textAlign: 'end' }}>
                Vänligen verifiera din e-postadress!
              </p>
            )}
            <S.Button color="color">Logga in</S.Button>
          </S.Form>
          <S.ButtonNew onClick={() => history.push('/signup')}>Registrera</S.ButtonNew>
          <Link to="/resetpassword">Glömt lösenord?</Link>
        </S.FormContainer>
      </S.Container>
    </S.Wrapper>
  )
}

export default SignIn
